/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/9/18
 * Copyright All Rights Reserved
 */
import React from 'react';

const SP3Logo = () => (
  <span className="sp3-logo" />
);

export default SP3Logo;
